var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareTexture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 785,
    height: 707,
    viewBox: "0 0 785 707",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M567.625 260.231C580.044 262.899 587.949 275.13 585.281 287.549L525.1 567.675C522.431 580.094 510.201 587.999 497.782 585.331L217.656 525.149C205.236 522.481 197.331 510.251 200 497.831L260.181 217.705C262.849 205.286 275.08 197.381 287.499 200.049L567.625 260.231Z",
    stroke: "#BBCBCB",
    strokeWidth: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M577.349 233.739C602.728 239.191 618.881 264.184 613.429 289.562L551.591 577.399C546.138 602.777 521.145 618.931 495.767 613.479L207.93 551.64C182.552 546.188 166.399 521.195 171.851 495.817L233.689 207.98C239.141 182.602 264.134 166.449 289.513 171.901L577.349 233.739Z",
    stroke: "#BBCBCB",
    strokeWidth: 18
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareTexture);
export default __webpack_public_path__ + "static/media/squareTexture.735c137c459dd2cf26427ca6b6dbc9f0.svg";
export { ForwardRef as ReactComponent };